import classNames from "classnames";
import { useMemo } from "react";

import { useStyles } from "./styles";

type TProps = {
  height?: number | string;
  variant?: "circle" | "rect" | "text";
  width?: number | string;
};

/** @deprecated Use the new `Skeleton` component from `components/ui/skeleton`. */
export const Skeleton: FC<TProps> = ({ children, className, height, ref, variant = "rect", width, ...restProps }) => {
  const classes = useStyles();

  const skeletonClassName = useMemo(() => {
    switch (variant) {
      case "circle":
        return classes.skeletonCircle;
      case "text":
        return classes.skeletonText;
      case "rect":
      default:
        return classes.skeletonRectangle;
    }
  }, [classes, variant]);

  return (
    <div {...restProps} className={classNames(skeletonClassName, className)} ref={ref} style={{ height, width }}>
      {children}
    </div>
  );
};
